import pino from 'pino';

const logger = pino({
    enabled: process.env.NODE_ENV !== 'production',
    level: process.env.NODE_ENV === 'production' ? 'silent' : 'info'
});

export default logger;